'use strict';

var _ = require('lodash');
var ConfigurationUserDefinedRefDataModalDirective = function ConfigurationUserDefinedRefDataModalDirective($timeout, $q) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/configuration-user-defined-ref-data-modal.html'),
    controller: 'ConfigurationUserDefinedRefDataModalController',
    scope: {
      type: '@',
      modalData: '='
    },
    link: function link(scope, element) {
      function updateValue(parentRowId) {
        var value = _.map(scope.gridSettings.source.records, function (row) {
          row._old = JSON.stringify(row._old);
          delete row.uid;
          return row;
        });
        scope.$emit('urd:dtd-changed', scope.type, parentRowId, value, scope.modalData);
      }
      function onCellEndEdit(event) {
        var cellData = _.pick(event.args, ['datafield', 'rowindex', 'value', 'oldvalue']);
        scope.markCellAsEdited(cellData.rowindex, cellData.datafield, cellData.value * 1, cellData.oldvalue * 1);
      }
      scope.hideModal = function (rememberValues) {
        var deferred = $q.defer();
        var parentRowId = scope.modalData.uid;
        element.modal('hide');
        if (rememberValues) {
          $timeout(function () {
            updateValue(parentRowId);
            deferred.resolve();
          }, 0);
        } else {
          deferred.resolve();
        }
        return deferred.promise.then(function () {
          scope.modalData = null;
          scope.gridSettings.jqxGrid('clearselection');
        });
      };
      element.on('shown.bs.modal', function () {
        element.find('#' + scope.gridId).on('cellendedit', onCellEndEdit);
      });
      element.on('hidden.bs.modal', function () {
        element.find('#' + scope.gridId).off('cellendedit', onCellEndEdit);
      });
    }
  };
};
ConfigurationUserDefinedRefDataModalDirective.$inject = ['$timeout', '$q'];
module.exports = ConfigurationUserDefinedRefDataModalDirective;